import environment from 'lib/environment';

let setAppIdCompleted = false;

/**
 * Convenience interface for working with the Castle.IO javascript API (for Devices Review).
 * See https://castle.io/docs/baseline and https://castle.io/docs/spa
 */
export class CastleIOWrapper {
  /**
   * In Castle.IO: Set the App ID value, 'autoTrack' to false, identify the logged-in user, and register the current page view).
   *
   * @param {string} userId: the user's ID from SCIM API.
   * @param {string} pageTitle: the english-only string of the current view/tab (e.g., Sign In & Security, Personal Info)
   * @param {object} [win = window]: the window object or a spy/mock for testing.
   * @param {Environment} [env = environment]: the environment from which to get configuration
   * @returns {boolean} True when the synchronous Castle.IO calls succeed (setAppId, autoTrack, identify, and trackPageView), false otherwise
   */
  identifyUserAndTrackPageInCastle(userId, pageTitle, win = window, env = environment) {
    if (win._castle) { // eslint-disable-line
      if (!setAppIdCompleted) {
        win._castle('setAppId', env.get().keys.castleIoAccount); // eslint-disable-line
        setAppIdCompleted = true;
      }
      win._castle('autoTrack', false); // eslint-disable-line
      win._castle('identify', userId); // eslint-disable-line
      win._castle('trackPageview', win.location.href.substring(win.location.href.lastIndexOf('/')), pageTitle); // eslint-disable-line
      return true;
    }
    return false;
  }

  /**
   * Returns the active client ID for the logged-in user from Castle.IO.
   *     It is very important that this call is made after the identifyUserAndTrackPageInCastle has been completed, otherwise no ID will be available from the API.
   *
   * The client id changes dynamically and frequently in Castle.ID, so it is important to get the most recent value prior to making API calls, such as getDeivces.
   *
   * @param {object} [win = window]:  the window object or a spy/mock for testing.
   * @returns {string} clientId of the logged-in user from Castle.IO
   */
  getCastleClientId(win = window) {
    return win._castle ? win._castle('getClientId') : '';  // eslint-disable-line
  }
}

export default __TEST__ ? {} : new CastleIOWrapper(); // eslint-disable-line
